import { atomWithStorage } from 'jotai/utils';

import { ELanguage } from '@~types/enums';

export const selectedLanguageAtom = atomWithStorage<ELanguage>('aurous_selectedLanguage', ELanguage.EN);
